import cryptojs from "crypto-js";

// First we get our unique key to encrypt our object
const password = process.env?.CRYPT_PASSWORD;
const salt = process.env?.CRYPT_SALT;
const ivSize = 128 / 32;
const key = cryptojs.algo.SHA256.create(password, salt);
const iv = cryptojs.lib.WordArray.create(key, ivSize * 4);

// Function to encode the object
export const encode = string => {
    try {
        const encrypted = cryptojs.AES.encrypt(string, key, { iv }).toString();
        return encrypted;
    } catch (error) {
        console.log(error);
        return "";
    }
};

// Function to decode the object
export const decode = string => {
    try {
        const decrypted = cryptojs.AES.decrypt(string, key, { iv }).toString(cryptojs.enc.Utf8);
        return decrypted;
    } catch (error) {
        console.log(error);
        return "";
    }
};
